import { Injectable, computed } from '@angular/core';

import { Observable, from } from 'rxjs';

import { AccionInmediata, BasicObjectSMI } from '@interfaces/index';
import { ConsumirApi } from '@utils/index';

@Injectable({
  providedIn: 'root'
})
export class AccionInmediataService {

  private controlador = computed(() => 'decisionevidencia');
  private api = new ConsumirApi(this.controlador());

  constructor() {}

  public obtenerTodos(idEmpresa:number):Observable<BasicObjectSMI[]>{
    return from(this.api.get<BasicObjectSMI[]>(`todos/${idEmpresa}`));
    // return this.http.get<>(`${this.apiURL}/todos/${idEmpresa}`);
  }

  public obtenerActivos(idEmpresa:number):Observable<BasicObjectSMI[]>{
    return from(this.api.get<BasicObjectSMI[]>(`${idEmpresa}`));
    // return this.http.get<coleccionDTO[]>(`${this.apiURL}/${idEmpresa}`);
  }

  public obtenerPorId(idEmpresa:number, idsupervisor: number): Observable<AccionInmediata>{
    return from(this.api.get<AccionInmediata>(`VersionMejorada/${idEmpresa}/${idsupervisor}`));
    // return this.http.get<accionInmediataDTO>(`${this.apiURL}/VersionMejorada/${idEmpresa}/${idsupervisor}`);
  }

  public crear(registro:AccionInmediata){
    return from(this.api.post<AccionInmediata, boolean>(`VersionMejorada`, registro));
    // return this.http.post(`${this.apiURL}/VersionMejorada`, registro);
  }

  public validarNombre(registro:AccionInmediata){
    return from(this.api.post<AccionInmediata, boolean>(`VersionMejorada/validarNombre`, registro));
    // return this.http.post(`${this.apiURL}/VersionMejorada/validarNombre`, registro);
  }

  public editar(id: number, registro:AccionInmediata){
    return from(this.api.put<AccionInmediata, boolean>(`VersionMejorada/${id}`, registro));
    // return this.http.put(`${this.apiURL}/VersionMejorada/${id}`, registro);
  }

  public borrar(id:number){
    return from(this.api.delete(`${id}`));
    // return this.http.delete(`${this.apiURL}/${id}`);
  }
}